export default "__VITE_ASSET__CxmDPhaa__"